import type { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '',
    loadComponent: () => import('./core/shell/shell.component').then(m => m.ShellComponent),
    children: [
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then(m => m.homeRoutes),
      },
      {
        path: 'leads',
        loadChildren: () => import('./features/leads/leads.routes').then(m => m.leadRoutes),
      },
      {
        path: 'companies',
        loadChildren: () => import('./features/companies/companies.routes').then(m => m.companyRoutes),
      },
      {
        path: 'metadata',
        loadChildren: () => import('./features/metadata/metadata.routes').then(m => m.metadataRoutes),
      },
      {
        path: 'opportunities/campaign',
        loadChildren: () => import('./features/campaigns/campaigns.routes').then(m => m.campaignRoutes),
      },
      {
        path: 'opportunities',
        loadChildren: () => import('./features/opportunities/opportunities.routes').then(m => m.opportunityRoutes),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then(m => m.userRoutes),
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles.routes').then(m => m.roleRoutes),
      },
      {
        path: 'report',
        loadChildren: () => import('./features/reports/reports.routes').then(m => m.reportRoutes),
      },
      {
        path: 'conversas',
        loadChildren: () => import('./features/encounters/encounters.routes').then(m => m.encounterRoutes),
      },
      {
        path: 'account',
        loadChildren: () => import('./features/account/account.routes').then(m => m.accountRoutes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];
